export default "<div *ngIf=\"show\" class=\"loader-container\">\n    <div class=\"lds-ripple\"><div></div><div></div></div>\n</div>"